<template>
    <div class="vehicle-new-upload-version">
        <el-form ref="formRef" :model="formData" :rules="formRules" label-width="120px" label-position="left">
            <el-row :gutter="15">
                <el-col :span="12">
                    <ocr-card-upload
                    ref="ocrCardUpload"
                    :showAbnormalFlag="showAbnormalFlag.carDrivingFileUrl"
                    :isNewOcrUpload="true"
                    :supplierCode="$store.state.supplier ? $store.state.supplier.supplierCode :supplierTab.supplierCode"
                    :cardTitle="uploadList[0].label"
                    :flag="uploadList[0].fileName + '#' + uploadList[0].fileUrl + '#' + uploadList[0].fileId"
                    :ocr="'vehicle'"
                    :label="uploadList[0].label"
                    :imgValue="uploadForm[uploadList[0].fileUrl]"
                    :imgExampleValue="imgExample[uploadList[0].fileUrl]"
                    :previewSrcList="uploadForm[uploadList[0].fileUrl] ? Object.values(uploadForm) : Object.values(imgExample)"
                    :disabled="copy || approve"
                    :drag="true"
                    :isRequired="uploadList[0].isRequired"
                    :showDel="true"
                    @delete="delFile('carDrivingFile')"
                    @uploadSuccess="handleUploadSuccess"
                    @preview="previewFile(uploadList[0].fileUrl)"
                    @aiCounter="aiCounter"
                    style="margin-top: 0"
                    />
                    <!-- <el-form-item class="customFormItem" v-if="isExistVehicleInfo">
                        <div class="tip">车辆信息已存在系统中，可以<span @click="handleViewVehicleInfoPanel">查看</span>确定是否直接使用</div>
                    </el-form-item> -->
                    <!-- 特权复制、审批中、编辑条件下车牌号置灰不可编辑 -->
                    <el-form-item label="车牌号" prop="licensePlateNo" class="licensePlateNo">
                        <el-input
                        v-model.trim="formData.licensePlateNo"
                        :disabled="copy || approve || !!formData.relationId"
                        placeholder="请输入车牌号"
                        @blur="handleQueryLicensePlateNo"
                        />
                    </el-form-item>
                    <el-form-item label="车辆所有人" prop="carOwner" class="carOwner">
                        <el-input :disabled="carOwnerDisabled" v-model.trim="formData.carOwner" placeholder="请输入车辆所有人" @change="handlecarOwnerChange"></el-input>
                    </el-form-item>
              
                    <el-form-item label="车辆归属" prop="carOwnerType" class="carOwnerType">
                        <m-select2
                            :disabled="copy || approve || isLegalSameName"
                            :optionNum="'SU_CAR_TYPE'"
                            :flag="'carOwnerType'"
                            :value="formData.carOwnerType"
                            :filterable="true"
                            @input="val => handleMSelectValue('carOwnerType', val)"
                        />
                    </el-form-item>

                    <el-form-item label="车辆所有人手机" prop="carOwnerPhone" class="carOwnerPhone">
                        <el-input :disabled="copy || approve" v-model.trim="formData.carOwnerPhone" maxlength="11" placeholder="请输入车辆所有人手机号码"></el-input>
                    </el-form-item>
                    <el-form-item label="行驶证检验有效期" prop="carDrivingEndTime" class="carDrivingEndTime">
                        <el-date-picker
                        :disabled="copy || approve"
                        v-model="formData.carDrivingEndTime"
                        type="date"
                        :placeholder="'请选择行驶证有效期至'"
                        style="width: 100%"
                        :picker-options="pickerOptionsCarDrivingEndTime"
                        value-format="yyyy-MM-dd"
                        />
                    </el-form-item>
                    <el-form-item label="行驶证发证日期" prop="mainIssueDate">
                        <el-date-picker
                            class="two-date"
                            :disabled="copy || approve"
                            value-format="yyyy-MM-dd"
                            v-model="formData.mainIssueDate"
                            type="date"
                            :placeholder="'请选择行驶证发证日期'"
                        ></el-date-picker>
                    </el-form-item>


                    <el-form-item label="车辆能源类型" prop="energyType" class="energyType">
                        <m-select
                            :disabled="copy || approve || !formData.carDrivingFileUrl"
                            :optionNum="'SRM_ENERGY_TYPE'"
                            :flag="'energyType'"
                            :value="formData.energyType"
                            :filterable="true"
                            @input="val => handleMSelectValue('energyType', val)"
                        ></m-select>
                    </el-form-item>
                    <el-form-item label="使用性质" prop="mainUserCharacter">
                        <el-input :disabled="copy || approve" v-model.trim="formData.mainUserCharacter" placeholder="请输入使用性质"></el-input>
                    </el-form-item>
                    <el-form-item label="车型" prop="lengthNameCn" class="lengthNameCn">
                        <advance
                            ref="lengthAdvance"
                            class="advance-item"
                            :params="paramsLength"
                            :disabled="copy || approve"
                            :mValue="formData.lengthNameCn"
                            @getAdvanceValue="data => setLengthAdvanceValue(['length', 'lengthNameCn', 'fuyouLengthKey', 'vehicleType', 'axlesNum','loadingVolume', 'insideLength', 'insideWidth', 'insideHeight'], data)"
                        ></advance>
                    </el-form-item>
                    <el-form-item label="外径长度(m)" prop="lengthInteriorLength" class="lengthInteriorLength">
                        <div>
                            <el-input :disabled="copy || approve" v-model.trim="formData.lengthInteriorLength" placeholder="请输入车辆外径长度" @input="onOutsideDiameterChange"></el-input>
                            <div style="color:red;font-size: 11px;line-height: 16px;">{{hasTract ? '车头为牵引车，外径长度≥牵引车头外径长度+挂车外径长度，可按实际修改' : '当车辆为非牵引车时，外径长度=行驶证上外廓尺寸长度'}}</div>
                        </div>
                    </el-form-item>
                    <el-form-item label="外径宽度(m)" prop="lengthInteriorWidth" class="lengthInteriorWidth">
                        <div>
                            <el-input :disabled="copy || approve" v-model.trim="formData.lengthInteriorWidth" placeholder="请输入车辆外径宽度" @input="onOutsideDiameterChange"></el-input>
                        </div>
                    </el-form-item>
                    <el-form-item label="外径高度(m)" prop="lengthInteriorHeight" class="lengthInteriorHeight">
                        <el-input :disabled="copy || approve" v-model.trim="formData.lengthInteriorHeight" placeholder="请输入车辆外径高度"></el-input>
                    </el-form-item>
                    <el-form-item label="车辆常用司机" prop="commonDriver" class="commonDriver">
                        <advance
                            :disabled="copy || approve"
                            class="advance-item"
                            :params="commonDriverParams"
                            :mValue="formData.commonDriver"
                            @getAdvanceValue="data => setAdvanceValue(['commonDriverCode', 'commonDriver', 'commonDriverPhone', 'delegateNo'], data)"
                        ></advance>
                    </el-form-item>
                    <el-form-item label="GPS设备号" prop="deviceNo">
                        <el-input v-model.trim="formData.deviceNo" :disabled="copy || approve" placeholder="请输入设备号"></el-input>
                    </el-form-item>
                    <el-form-item label="车辆排放标准" prop="vehicleEmissionsStandards">
                        <m-select
                            :disabled="copy || approve"
                            :optionNum="'SRM_VEHICLE_EMISSIONS_STANDARDS'"
                            :flag="'vehicleEmissionsStandards'"
                            :value="formData.vehicleEmissionsStandards"
                            :filterable="true"
                            @input="val => handleMSelectValue('vehicleEmissionsStandards', val)"
                        />
                    </el-form-item>
                    <el-form-item label="其他信息" prop="otherInformation" class="other-information-form-item">
                        <MCheckBox :values="formData.otherInformation" :dictCode="'SRM_CAR_OTHER_INFORMATION'" :disabled="copy || approve"
                            @change="val => handleCheckBoxChange(val, 'otherInformation')" >
                            <el-input
                                slot="checkbox-last"
                                class="other-information-explain-input"
                                :disabled="copy || approve"
                                v-model.trim="formData.otherInformationExplain"
                                placeholder="其他，请补充填写(10字以内)"
                                :maxlength="10"
                            />
                        </MCheckBox>
                    </el-form-item>
                    <el-form-item label="是否司机带车加入" class="lengthInteriorHeight">
                        <el-tooltip popper-class="with-car-popper" effect="dark" :content="isWithCar" :disabled="!isWithCar" placement="top">
                            <el-input disabled v-model.trim="formData.isWithCar"></el-input>
                        </el-tooltip>
                    </el-form-item>

                    <ocr-card-upload
                    :showAbnormalFlag="showAbnormalFlag.roadTransportFileUrl"
                    :isNewOcrUpload="true"
                    :supplierCode="$store.state.supplier ? $store.state.supplier.supplierCode :supplierTab.supplierCode"
                    ref="ocrCardUpload"
                    :cardTitle="'道路运输证（总质量大于4500kg时，必传）'"
                    :flag="uploadList[2].fileName + '#' + uploadList[2].fileUrl + '#' + uploadList[2].fileId"
                    :ocr="'roadTransport'"
                    :label="uploadList[2].label"
                    :imgValue="uploadForm[uploadList[2].fileUrl]"
                    :imgExampleValue="imgExample[uploadList[2].fileUrl]"
                    :previewSrcList="uploadForm[uploadList[2].fileUrl] ? Object.values(uploadForm) : Object.values(imgExample)"
                    :disabled="copy || approve"
                    :drag="true"
                    :isRequired="uploadList[2].isRequired"
                    :showDel="true"
                    @delete="delFile('roadTransportFile')"
                    @aiCounter="aiCounter"
                    @uploadSuccess="handleUploadSuccess"
                    @preview="previewFile(uploadList[2].fileUrl)"
                    />
                    <el-form-item label="道路运输证号" prop="roadTransportNo" class="roadTransportNo">
                        <el-input :disabled="copy || approve" v-model.trim="formData.roadTransportNo" placeholder="请输入道路运输证号"></el-input>
                    </el-form-item>
                    <el-form-item label="运输证有效期至" prop="roadTransportEndTime" class="roadTransportEndTime">
                        <el-date-picker
                        :disabled="copy || approve"
                        v-model="formData.roadTransportEndTime"
                        type="date"
                        value-format="yyyy-MM-dd"
                        :placeholder="'请选择运输证有效期至'"
                        style="width: 100%"
                        />
                    </el-form-item>
                    <ocr-card-upload
                    :showAbnormalFlag="showAbnormalFlag.trailerDrivingFileUrl"
                    :isNewOcrUpload="true"
                    :cardTitle="'挂车行驶证正副页'"
                    :flag="uploadList[7].fileName + '#' + uploadList[7].fileUrl + '#' + uploadList[7].fileId"
                    :ocr="'trailerVehicle'"
                    :label="uploadList[7].label"
                    :disabledTooltip="formData.carDrivingFileUrl ? '' : '先上传行驶证正副页后，才能上传挂车行驶证正副页！'"
                    :imgValue="uploadForm[uploadList[7].fileUrl]"
                    :imgExampleValue="imgExample[uploadList[7].fileUrl]"
                    :previewSrcList="uploadForm[uploadList[7].fileUrl] ? Object.values(uploadForm) : Object.values(imgExample)"
                    :disabled="copy || approve || !formData.carDrivingFileUrl"
                    :drag="true"
                    :isRequired="trailerRequired"
                    :showDel="true"
                    @delete="delFile('trailerDrivingFile')"
                    @uploadSuccess="handleUploadSuccess"
                    @preview="previewFile(uploadList[7].fileUrl)"
                    />
                    <el-form-item label="挂车车牌号" prop="trailerLicensePlateNo" class="trailerLicensePlateNo">
                        <el-input :disabled="copy || approve" v-model.trim="formData.trailerLicensePlateNo" placeholder="请输入挂车车牌号"></el-input>
                    </el-form-item>
                    <el-form-item label="超牌到期日期" prop="trailerDrivingEndDate" v-if="tdeVisible">
                        <el-date-picker
                            value-format="yyyy-MM-dd"
                            :disabled="copy || approve"
                            v-model="formData.trailerDrivingEndDate"
                            type="date"
                            :placeholder="'请选择超牌到期日期'"
                            style="width: 100%"
                        />
                    </el-form-item>
                  <!-- 交强险 -->
                  <ocr-card-upload
                    ref="ocrCardUpload"
                    :cardTitle="uploadList[5].label"
                    :flag="uploadList[5].fileName + '#' + uploadList[5].fileUrl + '#' + uploadList[5].fileId"
                    :ocr="''"
                    :label="uploadList[5].label"
                    :isRequired="insuranceRequired"
                    :imgValue="uploadForm[uploadList[5].fileUrl]"
                    :imgExampleValue="imgExample[uploadList[5].fileUrl]"
                    :previewSrcList="uploadForm[uploadList[5].fileUrl] ? Object.values(uploadForm) : Object.values(imgExample)"
                    :disabled="copy || approve"
                    :drag="copy || approve"
                    :accept="'image/*,.doc,.docx,.pdf'"
                    :showDel="true"
                    @delete="delFile('trafficInsuranceFile')"
                    @uploadSuccess="handleUploadSuccess"
                    @preview="previewFile(uploadList[5].fileUrl)"
                    ></ocr-card-upload>
                    <el-form-item label="交强险有效期" prop="trafficInsuranceEndTime" class="trafficInsuranceEndTime">
                        <el-date-picker
                            value-format="yyyy-MM-dd"
                            :disabled="copy || approve"
                            v-model="formData.trafficInsuranceEndTime"
                            type="date"
                            :placeholder="'请选择交强险有效期至'"
                            style="width: 100%"
                        />
                    </el-form-item>
                   
                    

                    <ocr-card-upload
                    ref="ocrCardUpload"
                    :showAbnormalFlag="showAbnormalFlag.photosVehicleFileUrl"
                    :cardTitle="uploadList[4].label"
                    :flag="uploadList[4].fileName + '#' + uploadList[4].fileUrl + '#' + uploadList[4].fileId"
                    :ocr="''"
                    :label="uploadList[4].label"
                    :imgValue="uploadForm[uploadList[4].fileUrl]"
                    :imgExampleValue="imgExample[uploadList[4].fileUrl]"
                    :previewSrcList="uploadForm[uploadList[4].fileUrl] ? Object.values(uploadForm) : Object.values(imgExample)"
                    :disabled="copy || approve"
                    :drag="true"
                    :isRequired="uploadList[4].isRequired"
                    :showDel="true"
                    @delete="delFile('photosVehicleFile')"
                    @uploadSuccess="handleUploadSuccess"
                    @preview="previewFile(uploadList[4].fileUrl)"
                    style="margin-top: 0"
                    />
                    
                    <div class="gutter"></div>

                    
                    
                    <!-- TODO：start 位置调整 -->
                    <!-- TODO：end 位置调整 -->
                </el-col>
                <el-col :span="12">
                    <ocr-card-upload
                    :showAbnormalFlag="showAbnormalFlag.carDrivingBottomFileUrl"
                    :isNewOcrUpload="true"
                    :supplierCode="$store.state.supplier ? $store.state.supplier.supplierCode :supplierTab.supplierCode"
                    ref="ocrCardUpload"
                    cardTitle="行驶证背面年审页 (如是新车，则上传空白年审页)"
                    :tooltip="(copy || approve) ? '' : '重新上传驾驶证正副页，年审页也需要重新上传！'"
                    :disabledTooltip="formData.carDrivingFileUrl ? '' : '先上传行驶证正副页后，才能上传年审页！'"
                    :flag="uploadList[1].fileName + '#' + uploadList[1].fileUrl + '#' + uploadList[1].fileId"
                    :ocr="'vehicleCheck'"
                    :label="uploadList[1].label"
                    :imgValue="uploadForm[uploadList[1].fileUrl]"
                    :imgExampleValue="imgExample[uploadList[1].fileUrl]"
                    :previewSrcList="uploadForm[uploadList[1].fileUrl] ? Object.values(uploadForm) : Object.values(imgExample)"
                    :disabled="copy || approve || !formData.carDrivingFileUrl"
                    :drag="true"
                    :isRequired="uploadList[1].isRequired"
                    :showDel="true"
                    @delete="delFile('carDrivingBottomFile')"
                    @uploadSuccess="handleUploadSuccess"
                    @preview="previewFile(uploadList[1].fileUrl)"
                    style="margin-top: 0"
                    />
                    <!-- 占位符 -->
                    <!-- <div class="form-gutter1"/> -->
                    <!-- <el-form-item class="customFormItem" v-if="isExistVehicleInfo">
                        <div class="tip"></div>
                    </el-form-item> -->
                    <el-form-item label="车辆类型" prop="mainVehicleType">
                        <m-select
                            :disabled="copy || approve"
                            :optionNum="'SRM_VEHICLE_TYPE'"
                            :flag="'mainVehicleType'"
                            :value="formData.mainVehicleType"
                            :filterable="true"
                            @input="getMainVehicleType"
                        ></m-select>
                    </el-form-item>
                    
                    <el-form-item label="总质量（kg）" prop="totalWeight">
                        <el-input :disabled="copy || approve" v-model.trim="formData.totalWeight" placeholder="请输入车辆总质量（kg）"></el-input>
                    </el-form-item>
                    <el-form-item label="整备质量（kg）" prop="grossWeight">
                        <el-input :disabled="copy || approve" v-model.trim="formData.grossWeight" placeholder="请输入整备质量（kg）"></el-input>
                    </el-form-item>
                    <el-form-item label="核定载重量（kg）" prop="lengthMaxWeight" class="lengthMaxWeight">
                        <el-input :disabled="copy || approve || !formData.carDrivingFileUrl" v-model.trim="formData.lengthMaxWeight" placeholder="请输入核定载重量"></el-input>
                    </el-form-item>
                    
                    <el-form-item label="行驶证注册日期" prop="mainRegisterDate">
                        <el-date-picker
                            class="two-date"
                            :disabled="copy || approve"
                            value-format="yyyy-MM-dd"
                            v-model="formData.mainRegisterDate"
                            type="date"
                            :placeholder="'请选择行驶证注册日期'"
                        ></el-date-picker>
                    </el-form-item>
                    
                    <el-form-item label="行驶证发证机关" prop="carDrivingAuthority">
                        <el-input :disabled="copy || approve" v-model.trim="formData.carDrivingAuthority" placeholder="请输入行驶证发证机关"></el-input>
                    </el-form-item>

                    <el-form-item label="车辆识别代码" prop="mainVin">
                        <el-input :disabled="copy || approve" v-model.trim="formData.mainVin" placeholder="请输入车辆识别代码"></el-input>
                    </el-form-item>  
                    <el-form-item label="车牌颜色" prop="licensePlateColor" class="licensePlateColor">
                        <m-select
                            :disabled="copy || approve"
                            :optionNum="'SRM_LICENSE_PLATE_COLOR'"
                            :flag="'licensePlateColor'"
                            :value="formData.licensePlateColor"
                            :filterable="true"
                            @input="val => handleMSelectValue('licensePlateColor', val)"
                        />
                    </el-form-item>
                    <el-form-item label="装载方量m³" prop="loadingVolume" class="loadingVolume">
                        <el-input :disabled="copy || approve" v-model.trim="formData.loadingVolume" placeholder="请输入装载方量m³"></el-input>
                    </el-form-item>
                    <el-form-item label="内径长度(m)" prop="insideLength">
                        <el-input :disabled="copy || approve" v-model.trim="formData.insideLength" placeholder="请输入车辆内径长度" @blur="onInsideWidthBlur('insideLength')"></el-input>
                    </el-form-item>
                    <div :style="{height: `${hasTract?32:16}px`}"></div>
                    <el-form-item label="内径宽度(m)" prop="insideWidth">
                        <el-input :disabled="copy || approve" v-model.trim="formData.insideWidth" placeholder="请输入车辆内径宽度" @blur="onInsideWidthBlur('insideWidth')"></el-input>
                    </el-form-item>
                    <el-form-item label="内径高度(m)" prop="insideHeight">
                        <div>
                            <el-input :disabled="copy || approve" v-model.trim="formData.insideHeight" placeholder="请输入车辆内径高度" @input="handleInhChange" @blur="onInsideWidthBlur('insideHeight')"></el-input>
                            <span v-if="innerHeightTipVisible" class="vnuv-inner-height-tip">内径高度偏高，请确认是否准确</span>
                        </div>
                    </el-form-item>
                    <el-form-item label="常用司机一手机" prop="commonDriverPhone" class="commonDriverPhone">
                        <el-input disabled v-model.trim="formData.commonDriverPhone" maxlength="11" placeholder="请输入常用司机一手机"></el-input>
                    </el-form-item>
                    <el-form-item label="轴数(个)" prop="axlesNum">
                        <m-select
                            :disabled="copy || approve"
                            :optionNum="'ANDC_AXLE_COUNT'"
                            :flag="'axlesNum'"
                            :value="formData.axlesNum"
                            :filterable="true"
                            @input="val => handleMSelectValue('axlesNum', val)"
                        />
                    </el-form-item>
                    <el-form-item label="车龄" prop="carAge">
                        <el-input :disabled="true" v-model.trim="formData.carAge"></el-input>
                    </el-form-item>
                    
                    <div style="padding-bottom: 84px;" :class="['form-gutter3']"/>

                    <ocr-card-upload
                    ref="ocrCardUpload"
                    :cardTitle="uploadList[3].label"
                    :flag="uploadList[3].fileName + '#' + uploadList[3].fileUrl + '#' + uploadList[3].fileId"
                    :ocr="''"
                    :label="uploadList[3].label"
                    :imgValue="uploadForm[uploadList[3].fileUrl]"
                    :imgExampleValue="imgExample[uploadList[3].fileUrl]"
                    :previewSrcList="uploadForm[uploadList[3].fileUrl] ? Object.values(uploadForm) : Object.values(imgExample)"
                    :disabled="copy || approve"
                    :drag="copy || approve"
                    :isRequired="uploadList[3].isRequired"
                    :accept="'image/*,.doc,.docx,.pdf'"
                    :hasTemp="uploadList[3].hasTemp && !copy && !approve"
                    :tempRequest="uploadList[3].tempRequest"
                    :showDel="true"
                    @delete="delFile('affiliatedFile')"
                    @uploadSuccess="handleUploadSuccess"
                    @preview="previewFile(uploadList[3].fileUrl)"
                    >
                    <!-- <div slot="fileName" v-if="formData.affiliatedFileUrl" style="color: #00BCBF;">{{ formData.affiliatedFileName }}</div> -->
                    </ocr-card-upload>
                    <el-form-item label="附件有效期至" prop="affiliatedEndTime" class="affiliatedEndTime">
                        <el-date-picker
                        value-format="yyyy-MM-dd"
                        :disabled="copy || approve"
                        v-model="formData.affiliatedEndTime"
                        type="date"
                        :placeholder="'请选择附件有效期至'"
                        style="width: 100%"
                        />
                    </el-form-item>
                    <div class="form-gutter3" style="padding-bottom: 0;"/>
                    <ocr-card-upload
                    :showAbnormalFlag="showAbnormalFlag.trailerDrivingVerifyFileUrl"
                    :cardTitle="'挂车行驶证年审页'"
                    :disabledTooltip="formData.carDrivingFileUrl ? '' : '先上传行驶证正副页后，才能上传挂车行驶证年审页！'"
                    :flag="uploadList[8].fileName + '#' + uploadList[8].fileUrl + '#' + uploadList[8].fileId"
                    :ocr="''"
                    :label="uploadList[8].label"
                    :imgValue="uploadForm[uploadList[8].fileUrl]"
                    :imgExampleValue="imgExample[uploadList[8].fileUrl]"
                    :previewSrcList="uploadForm[uploadList[8].fileUrl] ? Object.values(uploadForm) : Object.values(imgExample)"
                    :disabled="copy || approve || !formData.carDrivingFileUrl"
                    :drag="true"
                    :isRequired="trailerRequired"
                    :showDel="true"
                    @delete="delFile('trailerDrivingVerifyFile')"
                    @uploadSuccess="handleUploadSuccess"
                    @preview="previewFile(uploadList[8].fileUrl)"
                    />
                    
                    <div class="form-gutter3 pb34" :style="{paddingBottom: tdeVisible?'52px':'0px'}"/>
                    <!-- 商业保险 -->
                    <ocr-card-upload
                    ref="ocrCardUpload"
                    :cardTitle="uploadList[6].label"
                    :flag="uploadList[6].fileName + '#' + uploadList[6].fileUrl + '#' + uploadList[6].fileId"
                    :ocr="''"
                    :isRequired="insuranceRequired"
                    :label="uploadList[6].label"
                    :imgValue="uploadForm[uploadList[6].fileUrl]"
                    :imgExampleValue="imgExample[uploadList[6].fileUrl]"
                    :previewSrcList="uploadForm[uploadList[6].fileUrl] ? Object.values(uploadForm) : Object.values(imgExample)"
                    :disabled="copy || approve"
                    :drag="copy || approve"
                    :accept="'image/*,.doc,.docx,.pdf'"
                    :showDel="true"
                    @delete="delFile('businessInsuranceFile')"
                    @uploadSuccess="handleUploadSuccess"
                    @preview="previewFile(uploadList[6].fileUrl)"
                    ></ocr-card-upload>
                    <el-form-item label="商业保险有效期" prop="businessInsuranceEndTime" class="businessInsuranceEndTime">
                        <el-date-picker
                            value-format="yyyy-MM-dd"
                            :disabled="copy || approve"
                            v-model="formData.businessInsuranceEndTime"
                            type="date"
                            :placeholder="'请选择商业保险有效期至'"
                            style="width: 100%"
                        />
                    </el-form-item>
                    
                    
                </el-col>
            </el-row>
        </el-form>
        <!-- 输入车牌号系统带出车辆信息弹窗 -->
        <!-- <vehicle-info-modal ref="vehicleInfoModalRef" :vehicleInfo="vehicleInfo" @sure="handleSetFormData"></vehicle-info-modal> -->
    </div>
</template>
<script>
import OcrCardUpload from '../../../../../../../components/ocrCardUpload/Index.vue';
import advance from '../../../../../../../components/srmAdvance/index.vue';
import mSelect from '../../../../../../../components/Select.vue';
import mSelect2 from '@/components/lots/otpSelect2/index';
import MCheckBox from '../../../../../../../components/MCheckBox.vue';
// import VehicleInfoModal from './VehicleInfoModal.vue';
import { FORTY_FIVE_HUNDRED, CAR_OWNER_TYPE } from '../../../../../../../constant/constant.js';
import { uploadList } from '../uploadListConfig.js';
import { paramsLength, commonDriverParams, formData, formRules } from './config.js';
import methods,{INIT_OCR_RESULT_MAP} from './methods.js';
import { cloneDeep } from 'lodash';

export default {
    name: 'vehicleUploadVersion',
    components: { OcrCardUpload, advance, mSelect, mSelect2, MCheckBox },
    props: {
        supplierTab: {
            type: Object,
            default() {
                return {
                    supplierName: '',
                    propertyNature: ''
                };
            }
        },
        id: {
            type: String,
            default() {
                return '';
            }
        },
        title: {
            type: String,
            default() {
                return '';
            }
        },
        form: {
            type: Object,
            default() {
                return {};
            }
        },
        copy: {
            type: Boolean,
            default: false
        },
        approve: {
            type: Boolean,
            default: false
        },
        carOwnerDisabled: {
            type: Boolean,
            default: true
        },
        supplierName: {
            type: String,
            default() {
                return '';
            }
        },
        principalName: {
            type: String,
            default() {
                return '';
            }
        },
        businessType: {
            type: String,
            default() {
                return '';
            }
        },
        isLegalPersonSupplier: {
            type: Boolean,
            default: false
        },
        approvalStatus: {
            type: String,
            default() {
                return '';
            }
        }
    },
    data() {
        return {
            isApprove: false, // 是否在审批状态下
            // isExistVehicleInfo: false, // 输入车牌号校验是否存在车辆信息在系统数据库中
            // vehicleInfo: {}, // 存储车牌号带出来的车辆信息
            paramsLength,
            commonDriverParams,
            formData: JSON.parse(JSON.stringify(formData)),
            formRules: formRules(this),
            uploadList,
            fileObj: {},
            dictData: {},
            pickerOptionsCarDrivingEndTime: {
                disabledDate: time => {
                    return (
                        time.getTime() <= new Date().getTime()
                    );
                }
            },
            // 上传的文件图片
            uploadForm: {
                carDrivingFileUrl: '', // 行驶证正副面
                carDrivingBottomFileUrl: '', // 行驶证正副背面
                photosVehicleFileUrl: '', // 车辆照片
                roadTransportFileUrl: '', // 道路运输证
                affiliatedFileUrl: '', // 合作/租赁协议
                trafficInsuranceFileUrl: '', // 交强险
                businessInsuranceFileUrl: '', // 商业保险
                trailerDrivingFileUrl: '', // 挂车行驶证正副页
                trailerDrivingVerifyFileUrl: '', // 挂车行驶证年审页
            },
            // 示例封面图片
            imgExample: {
                carDrivingFileUrl: require('./example/drivingLicense.jpg'), // 行驶证正副面
                carDrivingBottomFileUrl: require('./example/carDrivingAnnualReview.png'), // 行驶证正副背面
                photosVehicleFileUrl: require('./example/photosVehicle.jpg'), // 车辆照片
                roadTransportFileUrl: require('./example/transportCertificate.jpg'), // 道路运输证
                affiliatedFileUrl: require('./example/affiliated.jpg'), // 合作/租赁协议
                trafficInsuranceFileUrl: require('./example/trafficInsurance.jpg'), // 强险
                businessInsuranceFileUrl: require('./example/businessInsurance.jpg'), // 商业保险
                trailerDrivingFileUrl: require('./example/trailerDriving.jpg'), // 挂车行驶证正副页 TODO
                trailerDrivingVerifyFileUrl: require('./example/trailerDrivingVerify.jpg'), // 挂车行驶证年审页 TODO
            },
            ocrData: { // OCR 返回的数据信息
                licensePlateNo: null,
                carOwner: null,
                energyType: null,
                lengthMaxWeight: null,
                grossWeight: null,
                carDrivingEndTime: null,
            },
            // 车辆主数据或车辆详情接口返回内径数据信息
            innerDiameterData: {
                insideLength: null,
                insideWidth: null,
                insideHeight: null,
            },
            innerHeightTipVisible: false, // 内径高度提示信息是否隐藏
            innerHeightTipTimeout: null, // 内径高度提示定时器
            lengthTipList: [], // 车辆提示数据
            lengthCodeList: [], // 车辆提示Code数据
            ocrResultMap: cloneDeep(INIT_OCR_RESULT_MAP),
            validateOcrData: [
                {field: 'carDrivingEndTime', label: '行驶证检验有效期', fileProp: 'carDrivingBottomFileUrl', licenseName: '行驶证年审页'},
                {field: 'roadTransportEndTime', label: '道路运输证有效期', fileProp: 'roadTransportFileUrl', licenseName: '道路运输证'},
                {field: 'licensePlateNo', label: '车牌号', fileProp: 'carDrivingFileUrl', licenseName: '行驶证正副页'},
                {field: 'carOwner', label: '车辆所有人', fileProp: 'carDrivingFileUrl', licenseName: '行驶证正副页'},
                {field: 'totalWeight', label: '总质量', fileProp: 'carDrivingFileUrl', licenseName: '行驶证正副页'},
                {field: 'grossWeight', label: '整备质量', fileProp: 'carDrivingFileUrl', licenseName: '行驶证正副页'},
                {field: 'lengthMaxWeight', label: '核定载重量', fileProp: 'carDrivingFileUrl', licenseName: '行驶证正副页'},
                {field: 'energyType', label: '车辆能源类型', fileProp: 'carDrivingFileUrl', licenseName: '行驶证正副页'},
                // {field: 'carOwnerType', label: '车辆归属', fileProp: 'carDrivingFileUrl', licenseName: '行驶证正副页'},
                // {field: 'loadingVolume', label: '车辆装载方量', fileProp: 'carDrivingFileUrl', licenseName: '行驶证正副页'},
                {field: 'roadTransportNo', label: '道路运输证号', fileProp: 'roadTransportFileUrl', licenseName: '道路运输证'},
                {field: 'mainVehicleType', label: '车辆类型', fileProp: 'carDrivingFileUrl', licenseName: '行驶证正副页'},
                {field: 'mainIssueDate', label: '行驶证发证日期', fileProp: 'carDrivingFileUrl', licenseName: '行驶证正副页'},
                {field: 'mainRegisterDate', label: '行驶证注册日期', fileProp: 'carDrivingFileUrl', licenseName: '行驶证正副页'},
                {field: 'carDrivingAuthority', label: '行驶证发证机关', fileProp: 'carDrivingFileUrl', licenseName: '行驶证正副页'},
                {field: 'mainVin', label: '车辆识别代码', fileProp: 'carDrivingFileUrl', licenseName: '行驶证正副页'},
            ],
            ocrQualityCount: {
                carDrivingFileUrl: 0,
                carDrivingBottomFileUrl: 0,
                roadTransportFileUrl: 0,
                trailerDrivingFileUrl: 0,
            },
            backupFormData: {},
            riskTypeSwitch: false,
            editToolSwitch: false,
            showAbnormalFlag: {
                carDrivingFileUrl: false,
                carDrivingBottomFileUrl: false,
                roadTransportFileUrl: false,
                photosVehicleFileUrl: false,
                trailerDrivingFileUrl: false,
                trailerDrivingVerifyFileUrl: false,
            },
        };
    },
    computed: {
        formDiff(){
            if(this.id){
                //编辑才需要判断表单是否有变化
                return JSON.stringify(this.formData).replace(/""/g, 'null') === JSON.stringify(this.backupFormData).replace(/""/g, 'null')
            }else{
                return false
            }
        },
        insuranceRequired(){
            // 供应商类型=物流供应商，主体性质=个体  且承运商=长合车、城配长合车、 
            // 车队长合车，【新建/编辑/特权复制】车辆信息，交强险、商业保险为必填
            let title=this.title;
            if(title.includes('新增')||title.includes('编辑')||this.copy||this.approve){
                // propertyNature 主体性质  2 个体
                // supplierType 供应商类型  70 物流供应商
                // transType 承运商类型  10 长合车、42 车队长合车、190 城配长合车
                const {propertyNature,supplierType,transType}=this.supplierTab
                if(propertyNature==='2'&&supplierType=='70'&&['10','42','190'].includes(transType)){
                    return true
                }
            }
     
            return false;
        },
        totalWeight() {
            return this.formData.totalWeight;
        },
        carOwnerType() {
            return this.formData.carOwnerType;
        },
        isWithCar(){
            return this.formData.isWithCar ? this.formData.isWithCar.replace(/,/g,'\n') : ''
        },
        hasTract() {
            return !!this.formData.mainVehicleType && this.dictData['SRM_VEHICLE_TYPE'][this.formData.mainVehicleType].indexOf('牵引') > -1
        },
        //挂车行驶证必填
        trailerRequired(){
            return !!this.formData.trailerLicensePlateNo || this.hasTract
        },
        // 超牌到期日期 显示
        tdeVisible() {
            return this.formData.trailerLicensePlateNo && this.formData.trailerLicensePlateNo.includes('超')
        },
        isLegalSameName() {
            // 主体性质是法人，且供应商名称和车辆所有人名称一致
            return this.isLegalPersonSupplier && this.supplierName === this.formData.carOwner
        }
    },
    methods: {
        ...methods
    },
    mounted() {
        const isSupplier = this.$store.state.supplier;
        const supplierCode = isSupplier ? isSupplier.supplierCode : this.$route.query.supplierCode;
        this.commonDriverParams.advanceUrl = '/supplierDriverInfos/simple/Drivers/' + supplierCode;
        this.getDictData();
        this.getLengthTipData()
    },
    watch: {
        insuranceRequired:{
            handler(nv){
                // 供应商类型=物流供应商，主体性质=个体  且承运商=长合车、城配长合车、 
                // 车队长合车，【新建/编辑/特权复制】车辆信息，交强险、商业保险为必填
                // 交强险有效期、商业保险有效期 设置必填
                const fields = ['trafficInsuranceEndTime', 'businessInsuranceEndTime'];
                fields.forEach(e => { this.formRules[e][0].required = nv; });
            },
            immediate:true,
        },
        totalWeight(nVal) {
            // 车重超过4500KG, 道路运输证必填,运输证有效期至,道路运输证号必填
            let boole = false;
            const fields = ['roadTransportFileName', 'roadTransportEndTime', 'roadTransportNo'];
            if (Number(nVal) >= FORTY_FIVE_HUNDRED) { boole = true; }
            const rtIndex = this.uploadList.findIndex(item => item.fileName === 'roadTransportFileName');
            this.uploadList[rtIndex].isRequired = boole;
            fields.forEach(e => { this.formRules[e][0].required = boole; });
        },
        carOwnerType(nVal) {
            let boole = false;
            const fields = ['affiliatedFileName', 'affiliatedEndTime'];
            // 车辆归属为合作、租赁，合作/租赁协议、附件有效期至必填
            if ([CAR_OWNER_TYPE.AFFILIATION, CAR_OWNER_TYPE.LEASE].includes(nVal)) {
                boole = true;
            }
            const aIndex = this.uploadList.findIndex(item => item.fileName === 'affiliatedFileName');
            this.uploadList[aIndex].isRequired = boole;
            fields.forEach(e => { this.formRules[e][0].required = boole; });
        },
        'formData.trailerLicensePlateNo'(nVal) {
            const tdIndex = this.uploadList.findIndex(item => item.fileName === 'trailerDrivingFileName');
            this.uploadList[tdIndex].isRequired = !!nVal;
            const verifyIdx = this.uploadList.findIndex(item => item.fileName === 'trailerDrivingVerifyFileName');
            this.uploadList[verifyIdx].isRequired = !!nVal;
        },
        formDiff(v){
            this.$emit('hasDiff', v)
        }
    }
};
</script>
<style lang="less">
@import url("./newUploadVersion.less");

.with-car-popper{
    max-width: 300px;
    white-space: pre-line;
}
</style>